<template>
  <div>
    <IntercomMessages v-if="authStore.isAuthenticated" />
    <router-view />
    <Toast
      :pt="{
        summary: {
          class: 'mb-2 block'
        },
        detail: {
          class: 'mt-0',
        },
      }"
      error-icon="pi pi-exclamation-triangle"
    >
    </Toast>
    <DynamicDialog />
  </div>
</template>

<script>
import Toast from 'primevue/toast';
import { compareLocalStorageTokenToStoreToken } from '@/utils/eventListeners';
import DynamicDialog from 'primevue/dynamicdialog';
import IntercomMessages from '@/components/intercomMessages';
import { useAuthStore } from '@/stores';

export default {
  components: {
    Toast,
    DynamicDialog,
    IntercomMessages,
  },
  computed: {
    authStore() {
      return useAuthStore();
    },
  },
  mounted() {
    if ('hidden' in document) {
      document.addEventListener('visibilitychange', compareLocalStorageTokenToStoreToken);
    }
  },
  beforeUnmount() {
    if ('hidden' in document) {
      document.removeEventListener('visibilitychange', compareLocalStorageTokenToStoreToken);
    }
  },
};
</script>
